


























import { Vue, Component, Watch } from 'vue-property-decorator';
import { Toast, List } from 'vant';
Vue.use(Toast).use(List);
import { recharge } from '../api';
import { namespace, State, Mutation } from 'vuex-class';
import moment from 'moment';
const yuShangModule = namespace('yuShang');
@Component
export default class Record extends Vue {
  @yuShangModule.State('activityId') activityId: any;
  list: any = [];
  loading = false;
  finished = false;
  page = 1;
  created() {
    Toast.loading({
      duration: 0,
      forbidClick: true,
    });
  }
  mounted() {
    this.onLoad();
  }
  @Watch('activityId')
  onActivityIdChange() {
    this.onLoad();
  }
  async onLoad() {
    Toast.clear();
    try {
      if (!this.activityId) {
        return;
      }
      this.loading = true;
      const res: any = await recharge(
        this.activityId,
        this.page,
        window.localStorage.getItem('unionid')
          ? window.localStorage.getItem('unionid')
          : '',
      );
      this.loading = false;
      if (res.code === 200 && res.data.length > 0) {
        this.page++;
        this.list = [...res.data, ...this.list];
      } else {
        this.finished = true;
      }
    } catch (error) {
      console.log(error);
    }
  }

  formatDate(val: string) {
    return moment(Number(+val * 1000)).format('YYYY/MM/DD HH:mm:ss');
  }
}
